import './assets/main.css';var z = Object.defineProperty;
var C = Object.getOwnPropertySymbols;
var R = Object.prototype.hasOwnProperty, N = Object.prototype.propertyIsEnumerable;
var M = (r, n, a) => n in r ? z(r, n, { enumerable: !0, configurable: !0, writable: !0, value: a }) : r[n] = a, w = (r, n) => {
  for (var a in n || (n = {}))
    R.call(n, a) && M(r, a, n[a]);
  if (C)
    for (var a of C(n))
      N.call(n, a) && M(r, a, n[a]);
  return r;
};
import { Alert as yr } from "./components/Alert/index.js";
import { B as Cr } from "./index-_4tGUpBv.js";
import { Button as Sr } from "./components/Button/index.js";
import { Checkbox as Pr } from "./components/Checkbox/index.js";
import { Label as Er } from "./components/Label/index.js";
import { Menu as Lr } from "./components/Menu/index.js";
import { Modal as Wr } from "./components/Modal/index.js";
import { MultiSelect as Fr } from "./components/MultiSelect/index.js";
import { Radio as Ir } from "./components/Radio/index.js";
import { Select as Br } from "./components/Select/index.js";
import { Tabs as zr } from "./components/Tabs/index.js";
import { Stepper as Nr } from "./components/Stepper/index.js";
import { TextField as Gr } from "./components/TextField/index.js";
import { Tile as Jr } from "./components/Tile/index.js";
import { T as Qr } from "./index-DyUcQgRF.js";
import { Switch as Yr } from "./components/Switch/index.js";
import { Avatar as ro } from "./components/Avatar/index.js";
import { SegmentedControl as no } from "./components/SegmentedControl/index.js";
import { Table as io } from "./components/Table/index.js";
import { ProgressIndicator as eo } from "./components/ProgressIndicator/index.js";
import { DatePicker as so } from "./components/DatePicker/index.js";
import { ColorPicker as mo } from "./components/ColorPicker/index.js";
import { Dialog as fo } from "./components/Dialog/index.js";
import { Highlight as $o } from "./components/Highlight/index.js";
import { PageTitle as ho } from "./components/PageTitle/index.js";
import { jsx as h, jsxs as q } from "react/jsx-runtime";
import { u as j, q as L, s as d, g as k, t as f, v as G, D as U, w as J, M as K, x as Q } from "./factory-BnRIVbT0.js";
import { p as X } from "./px-D2OpBVXb.js";
import { e as S, r as Y } from "./rem-CMQJ_ZTp.js";
import { useRef as Z, useState as rr, useCallback as V, useEffect as P } from "react";
import { a as T } from "./get-contrast-color-CmlzE11I.js";
import { u as A } from "./use-isomorphic-effect-CiIycTKV.js";
function E(r) {
  return r === "auto" || r === "dark" || r === "light";
}
function or({
  key: r = "mantine-color-scheme-value"
} = {}) {
  let n;
  return {
    get: (a) => {
      if (typeof window == "undefined")
        return a;
      try {
        const o = window.localStorage.getItem(r);
        return E(o) ? o : a;
      } catch (o) {
        return a;
      }
    },
    set: (a) => {
      try {
        window.localStorage.setItem(r, a);
      } catch (o) {
        console.warn(
          "[@mantine/core] Local storage color scheme manager was unable to save color scheme.",
          o
        );
      }
    },
    subscribe: (a) => {
      n = (o) => {
        o.storageArea === window.localStorage && o.key === r && E(o.newValue) && a(o.newValue);
      }, window.addEventListener("storage", n);
    },
    unsubscribe: () => {
      window.removeEventListener("storage", n);
    },
    clear: () => {
      window.localStorage.removeItem(r);
    }
  };
}
function nr() {
  const r = j(), n = L(), a = d(r.breakpoints).reduce((o, t) => {
    const i = r.breakpoints[t].includes("px"), e = X(r.breakpoints[t]), l = i ? `${e - 0.1}px` : S(e - 0.1), s = i ? `${e}px` : S(e);
    return `${o}@media (max-width: ${l}) {.mantine-visible-from-${t} {display: none !important;}}@media (min-width: ${s}) {.mantine-hidden-from-${t} {display: none !important;}}`;
  }, "");
  return /* @__PURE__ */ h(
    "style",
    {
      "data-mantine-styles": "classes",
      nonce: n == null ? void 0 : n(),
      dangerouslySetInnerHTML: { __html: a }
    }
  );
}
function x(r) {
  return Object.entries(r).map(([n, a]) => `${n}: ${a};`).join("");
}
function p(r, n) {
  return (Array.isArray(r) ? r : [r]).reduce((o, t) => `${t}{${o}}`, n);
}
function ar(r, n) {
  const a = x(r.variables), o = a ? p(n, a) : "", t = x(r.dark), i = x(r.light), e = t ? p(n === ":host" ? `${n}([data-mantine-color-scheme="dark"])` : `${n}[data-mantine-color-scheme="dark"]`, t) : "", l = i ? p(n === ":host" ? `${n}([data-mantine-color-scheme="light"])` : `${n}[data-mantine-color-scheme="light"]`, i) : "";
  return `${o}${e}${l}`;
}
function v({
  theme: r,
  color: n,
  colorScheme: a,
  name: o = n,
  withColorValues: t = !0
}) {
  if (!r.colors[n])
    return {};
  if (a === "light") {
    const l = k(r, "light"), s = {
      [`--mantine-color-${o}-text`]: `var(--mantine-color-${o}-filled)`,
      [`--mantine-color-${o}-filled`]: `var(--mantine-color-${o}-${l})`,
      [`--mantine-color-${o}-filled-hover`]: `var(--mantine-color-${o}-${l === 9 ? 8 : l + 1})`,
      [`--mantine-color-${o}-light`]: f(r.colors[n][l], 0.1),
      [`--mantine-color-${o}-light-hover`]: f(r.colors[n][l], 0.12),
      [`--mantine-color-${o}-light-color`]: `var(--mantine-color-${o}-${l})`,
      [`--mantine-color-${o}-outline`]: `var(--mantine-color-${o}-${l})`,
      [`--mantine-color-${o}-outline-hover`]: f(r.colors[n][l], 0.05)
    };
    return t ? w({
      [`--mantine-color-${o}-0`]: r.colors[n][0],
      [`--mantine-color-${o}-1`]: r.colors[n][1],
      [`--mantine-color-${o}-2`]: r.colors[n][2],
      [`--mantine-color-${o}-3`]: r.colors[n][3],
      [`--mantine-color-${o}-4`]: r.colors[n][4],
      [`--mantine-color-${o}-5`]: r.colors[n][5],
      [`--mantine-color-${o}-6`]: r.colors[n][6],
      [`--mantine-color-${o}-7`]: r.colors[n][7],
      [`--mantine-color-${o}-8`]: r.colors[n][8],
      [`--mantine-color-${o}-9`]: r.colors[n][9]
    }, s) : s;
  }
  const i = k(r, "dark"), e = {
    [`--mantine-color-${o}-text`]: `var(--mantine-color-${o}-4)`,
    [`--mantine-color-${o}-filled`]: `var(--mantine-color-${o}-${i})`,
    [`--mantine-color-${o}-filled-hover`]: `var(--mantine-color-${o}-${i === 9 ? 8 : i + 1})`,
    [`--mantine-color-${o}-light`]: f(
      r.colors[n][Math.max(0, i - 2)],
      0.15
    ),
    [`--mantine-color-${o}-light-hover`]: f(
      r.colors[n][Math.max(0, i - 2)],
      0.2
    ),
    [`--mantine-color-${o}-light-color`]: `var(--mantine-color-${o}-${Math.max(i - 5, 0)})`,
    [`--mantine-color-${o}-outline`]: `var(--mantine-color-${o}-${Math.max(i - 4, 0)})`,
    [`--mantine-color-${o}-outline-hover`]: f(
      r.colors[n][Math.max(i - 4, 0)],
      0.05
    )
  };
  return t ? w({
    [`--mantine-color-${o}-0`]: r.colors[n][0],
    [`--mantine-color-${o}-1`]: r.colors[n][1],
    [`--mantine-color-${o}-2`]: r.colors[n][2],
    [`--mantine-color-${o}-3`]: r.colors[n][3],
    [`--mantine-color-${o}-4`]: r.colors[n][4],
    [`--mantine-color-${o}-5`]: r.colors[n][5],
    [`--mantine-color-${o}-6`]: r.colors[n][6],
    [`--mantine-color-${o}-7`]: r.colors[n][7],
    [`--mantine-color-${o}-8`]: r.colors[n][8],
    [`--mantine-color-${o}-9`]: r.colors[n][9]
  }, e) : e;
}
function ir(r) {
  return !!r && typeof r == "object" && "mantine-virtual-color" in r;
}
function g(r, n, a) {
  d(n).forEach(
    (o) => Object.assign(r, { [`--mantine-${a}-${o}`]: n[o] })
  );
}
const W = (r) => {
  const n = k(r, "light"), a = r.defaultRadius in r.radius ? r.radius[r.defaultRadius] : Y(r.defaultRadius), o = {
    variables: {
      "--mantine-scale": r.scale.toString(),
      "--mantine-cursor-type": r.cursorType,
      "--mantine-color-scheme": "light dark",
      "--mantine-webkit-font-smoothing": r.fontSmoothing ? "antialiased" : "unset",
      "--mantine-moz-font-smoothing": r.fontSmoothing ? "grayscale" : "unset",
      "--mantine-color-white": r.white,
      "--mantine-color-black": r.black,
      "--mantine-line-height": r.lineHeights.md,
      "--mantine-font-family": r.fontFamily,
      "--mantine-font-family-monospace": r.fontFamilyMonospace,
      "--mantine-font-family-headings": r.headings.fontFamily,
      "--mantine-heading-font-weight": r.headings.fontWeight,
      "--mantine-heading-text-wrap": r.headings.textWrap,
      "--mantine-radius-default": a,
      // Primary colors
      "--mantine-primary-color-filled": `var(--mantine-color-${r.primaryColor}-filled)`,
      "--mantine-primary-color-filled-hover": `var(--mantine-color-${r.primaryColor}-filled-hover)`,
      "--mantine-primary-color-light": `var(--mantine-color-${r.primaryColor}-light)`,
      "--mantine-primary-color-light-hover": `var(--mantine-color-${r.primaryColor}-light-hover)`,
      "--mantine-primary-color-light-color": `var(--mantine-color-${r.primaryColor}-light-color)`
    },
    light: {
      "--mantine-primary-color-contrast": T(r, "light"),
      "--mantine-color-bright": "var(--mantine-color-black)",
      "--mantine-color-text": r.black,
      "--mantine-color-body": r.white,
      "--mantine-color-error": "var(--mantine-color-red-6)",
      "--mantine-color-placeholder": "var(--mantine-color-gray-5)",
      "--mantine-color-anchor": `var(--mantine-color-${r.primaryColor}-${n})`,
      "--mantine-color-default": "var(--mantine-color-white)",
      "--mantine-color-default-hover": "var(--mantine-color-gray-0)",
      "--mantine-color-default-color": "var(--mantine-color-black)",
      "--mantine-color-default-border": "var(--mantine-color-gray-4)",
      "--mantine-color-dimmed": "var(--mantine-color-gray-6)"
    },
    dark: {
      "--mantine-primary-color-contrast": T(r, "dark"),
      "--mantine-color-bright": "var(--mantine-color-white)",
      "--mantine-color-text": "var(--mantine-color-dark-0)",
      "--mantine-color-body": "var(--mantine-color-dark-7)",
      "--mantine-color-error": "var(--mantine-color-red-8)",
      "--mantine-color-placeholder": "var(--mantine-color-dark-3)",
      "--mantine-color-anchor": `var(--mantine-color-${r.primaryColor}-4)`,
      "--mantine-color-default": "var(--mantine-color-dark-6)",
      "--mantine-color-default-hover": "var(--mantine-color-dark-5)",
      "--mantine-color-default-color": "var(--mantine-color-white)",
      "--mantine-color-default-border": "var(--mantine-color-dark-4)",
      "--mantine-color-dimmed": "var(--mantine-color-dark-2)"
    }
  };
  g(o.variables, r.breakpoints, "breakpoint"), g(o.variables, r.spacing, "spacing"), g(o.variables, r.fontSizes, "font-size"), g(o.variables, r.lineHeights, "line-height"), g(o.variables, r.shadows, "shadow"), g(o.variables, r.radius, "radius"), r.colors[r.primaryColor].forEach((i, e) => {
    o.variables[`--mantine-primary-color-${e}`] = `var(--mantine-color-${r.primaryColor}-${e})`;
  }), d(r.colors).forEach((i) => {
    const e = r.colors[i];
    if (ir(e)) {
      Object.assign(
        o.light,
        v({
          theme: r,
          name: e.name,
          color: e.light,
          colorScheme: "light",
          withColorValues: !0
        })
      ), Object.assign(
        o.dark,
        v({
          theme: r,
          name: e.name,
          color: e.dark,
          colorScheme: "dark",
          withColorValues: !0
        })
      );
      return;
    }
    e.forEach((l, s) => {
      o.variables[`--mantine-color-${i}-${s}`] = l;
    }), Object.assign(
      o.light,
      v({
        theme: r,
        color: i,
        colorScheme: "light",
        withColorValues: !1
      })
    ), Object.assign(
      o.dark,
      v({
        theme: r,
        color: i,
        colorScheme: "dark",
        withColorValues: !1
      })
    );
  });
  const t = r.headings.sizes;
  return d(t).forEach((i) => {
    o.variables[`--mantine-${i}-font-size`] = t[i].fontSize, o.variables[`--mantine-${i}-line-height`] = t[i].lineHeight, o.variables[`--mantine-${i}-font-weight`] = t[i].fontWeight || r.headings.fontWeight;
  }), o;
};
function tr({ theme: r, generator: n }) {
  const a = W(r), o = n == null ? void 0 : n(r);
  return o ? G(a, o) : a;
}
const y = W(U);
function er(r) {
  const n = {
    variables: {},
    light: {},
    dark: {}
  };
  return d(r.variables).forEach((a) => {
    y.variables[a] !== r.variables[a] && (n.variables[a] = r.variables[a]);
  }), d(r.light).forEach((a) => {
    y.light[a] !== r.light[a] && (n.light[a] = r.light[a]);
  }), d(r.dark).forEach((a) => {
    y.dark[a] !== r.dark[a] && (n.dark[a] = r.dark[a]);
  }), n;
}
function lr(r) {
  return `
  ${r}[data-mantine-color-scheme="dark"] { --mantine-color-scheme: dark; }
  ${r}[data-mantine-color-scheme="light"] { --mantine-color-scheme: light; }
`;
}
function _({
  cssVariablesSelector: r,
  deduplicateCssVariables: n
}) {
  const a = j(), o = L(), t = J(), i = tr({ theme: a, generator: t }), e = r === ":root" && n, l = e ? er(i) : i, s = ar(l, r);
  return s ? /* @__PURE__ */ h(
    "style",
    {
      "data-mantine-styles": !0,
      nonce: o == null ? void 0 : o(),
      dangerouslySetInnerHTML: {
        __html: `${s}${e ? "" : lr(r)}`
      }
    }
  ) : null;
}
_.displayName = "@mantine/CssVariables";
function sr() {
  const r = console.error;
  console.error = (...n) => {
    n.length > 1 && typeof n[0] == "string" && n[0].toLowerCase().includes("extra attributes from the server") && typeof n[1] == "string" && n[1].toLowerCase().includes("data-mantine-color-scheme") || r(...n);
  };
}
function $(r, n) {
  var t, i;
  const a = typeof window != "undefined" && "matchMedia" in window && ((t = window.matchMedia("(prefers-color-scheme: dark)")) == null ? void 0 : t.matches), o = r !== "auto" ? r : a ? "dark" : "light";
  (i = n()) == null || i.setAttribute("data-mantine-color-scheme", o);
}
function cr({
  manager: r,
  defaultColorScheme: n,
  getRootElement: a,
  forceColorScheme: o
}) {
  const t = Z(null), [i, e] = rr(() => r.get(n)), l = o || i, s = V(
    (c) => {
      o || ($(c, a), e(c), r.set(c));
    },
    [r.set, l, o]
  ), b = V(() => {
    e(n), $(n, a), r.clear();
  }, [r.clear, n]);
  return P(() => (r.subscribe(s), r.unsubscribe), [r.subscribe, r.unsubscribe]), A(() => {
    $(r.get(n), a);
  }, []), P(() => {
    var m;
    if (o)
      return $(o, a), () => {
      };
    o === void 0 && $(i, a), typeof window != "undefined" && "matchMedia" in window && (t.current = window.matchMedia("(prefers-color-scheme: dark)"));
    const c = (u) => {
      i === "auto" && $(u.matches ? "dark" : "light", a);
    };
    return (m = t.current) == null || m.addEventListener("change", c), () => {
      var u;
      return (u = t.current) == null ? void 0 : u.removeEventListener("change", c);
    };
  }, [i, o]), { colorScheme: l, setColorScheme: s, clearColorScheme: b };
}
function dr({
  respectReducedMotion: r,
  getRootElement: n
}) {
  A(() => {
    var a;
    r && ((a = n()) == null || a.setAttribute("data-respect-reduced-motion", "true"));
  }, [r]);
}
sr();
function mr({
  theme: r,
  children: n,
  getStyleNonce: a,
  withStaticClasses: o = !0,
  withGlobalClasses: t = !0,
  deduplicateCssVariables: i = !0,
  withCssVariables: e = !0,
  cssVariablesSelector: l = ":root",
  classNamesPrefix: s = "mantine",
  colorSchemeManager: b = or(),
  defaultColorScheme: c = "light",
  getRootElement: m = () => document.documentElement,
  cssVariablesResolver: u,
  forceColorScheme: F,
  stylesTransform: H,
  env: I
}) {
  const { colorScheme: O, setColorScheme: B, clearColorScheme: D } = cr({
    defaultColorScheme: c,
    forceColorScheme: F,
    manager: b,
    getRootElement: m
  });
  return dr({
    respectReducedMotion: (r == null ? void 0 : r.respectReducedMotion) || !1,
    getRootElement: m
  }), /* @__PURE__ */ h(
    K.Provider,
    {
      value: {
        colorScheme: O,
        setColorScheme: B,
        clearColorScheme: D,
        getRootElement: m,
        classNamesPrefix: s,
        getStyleNonce: a,
        cssVariablesResolver: u,
        cssVariablesSelector: l,
        withStaticClasses: o,
        stylesTransform: H,
        env: I
      },
      children: /* @__PURE__ */ q(Q, { theme: r, children: [
        e && /* @__PURE__ */ h(
          _,
          {
            cssVariablesSelector: l,
            deduplicateCssVariables: i
          }
        ),
        t && /* @__PURE__ */ h(nr, {}),
        n
      ] })
    }
  );
}
mr.displayName = "@mantine/core/MantineProvider";
export {
  yr as Alert,
  ro as Avatar,
  Cr as Badge,
  Sr as Button,
  Pr as Checkbox,
  mo as ColorPicker,
  so as DatePicker,
  fo as Dialog,
  $o as Highlight,
  Er as Label,
  eo as Loader,
  Lr as Menu,
  Wr as Modal,
  Fr as MultiSelect,
  ho as PageTitle,
  mr as PlumProvider,
  Ir as Radio,
  no as SegmentedControl,
  Br as Select,
  Nr as Stepper,
  Yr as Switch,
  io as Table,
  zr as Tabs,
  Gr as TextField,
  Jr as Tile,
  Qr as Tooltip
};
